import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { oneformBFFNdpsSend } from 'src/bff';
import {
	FormController,
	isLowRating,
	isNoRating,
	useOneFormContext,
} from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { DpsData } from 'src/feature-service/es-oneform-core-feature-service/types';
import {
	CEMVentaProductoThankYouComerciales,
	getStepsVentaProductoComerciales,
} from 'src/forms/Cem/CEMVentaProductoComerciales/';
import {
	checkUndefinedsInData,
	formatSinRespuestaValue,
	getCemDate,
	getSfAddressRest,
	sanitizeKvps,
	stepNameToFieldName,
	valueWrongConcesion,
	valueWrongMarca,
	valueWrongModelo,
	valueWrongPersona,
} from 'src/forms/Cem/helpers';
import { formatHeaders, formDataBuilder } from 'src/forms/format-fields';
import {
	addRemovedStep,
	getIndexInSteps,
	removeMultipleStepsAndResetScreenIndex,
	resetStepsScreenIndex,
} from 'src/forms/helpers/add-remove-steps';
import { formatToTwoChars, strTitlelize } from 'src/helpers';
import {
	FormDataGroup,
	FormInfo,
	IdDealer,
	IdOrder,
	IdPerson,
	IdVehicle,
	OneFormState,
	Steps,
} from 'src/types';

export interface CEMVentaProductoFormComercialesProps {
	idOrder?: IdOrder;
	idPerson: IdPerson;
	idVehicle: IdVehicle;
	idDealer?: IdDealer;
	dpsData: DpsData;
	installation?: IdDealer;
}

export function CEMVentaProductoFormComerciales(
	props: CEMVentaProductoFormComercialesProps,
) {
	const { idOrder, idPerson, idVehicle, idDealer, dpsData, installation } =
		props;
	const { initializeForm, handleNextStep } = useOneFormContext();
	const { formData } = useSelector((state: OneFormState) => state);
	const { fields } = formData;
	const store = useStore();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const urlParams = new URLSearchParams(window.location.search);
	const dev = urlParams.get('dev') !== null;

	const [isElectrico, setIsElectrico] = useState(
		urlParams.get('VGED_Electric')
			? urlParams.get('VGED_Electric') == 'True'
			: idVehicle?.VGED_Electric__c == 'true',
	);
	const [isHibrido, setIsHibrido] = useState(
		urlParams.get('VGED_Hybrid')
			? urlParams.get('VGED_Hybrid') == 'True'
			: idVehicle?.VGED_HybridElectric__c == 'true',
	);
	const [isCamper, setIsCamper] = useState(
		idVehicle?.VGED_ModelGroup__c?.toLowerCase().includes('california'),
	);
	const [carline, setCarline] = useState(idVehicle?.VGED_ModelGroup__c);

	const {
		isDatosCorrectos,
		datoIncorrecto,
		confirmacionConcesion,
		enviarConcesion,
	} = fields;

	const getInstallationName = () => {
		return strTitlelize(
			installation?.VGED_CommercialName__c
				? installation.VGED_CommercialName__c
				: idDealer?.VGED_CommercialName__c
				? idDealer.VGED_CommercialName__c
				: '',
		);
	};

	const NuevoFormData: Partial<FormDataGroup> = {
		headers: {
			FORM_DETAILS: 'CEM Venta Producto',
			FORM_OBJECTIVE: 'Encuesta',
			DPS_TOKEN: 'LCV_DDB_FRM_CEM_PRODUCTO',
			FORM_ID: 'Email_B04_C01_CEM_Product',
		},
		fields: {
			formName: 'cem-venta-producto',
			formType: 'otherform',
			pageCategory: 'Encuesta',
			name: idPerson.FirstName,
			surname: idPerson.LastName,
			secondSurname: idPerson.MiddleName,
			installation: getInstallationName(),
		}, // Analítica
	};

	const sendSurvey = () => {
		const { formData }: OneFormState = store.getState();
		const { fields } = formData;

		return !(
			// negation
			(
				(fields.isDatosCorrectos == 'false' &&
					fields.datoIncorrecto == valueWrongMarca) ||
				(fields.isDatosCorrectos == 'false' &&
					fields.datoIncorrecto == valueWrongPersona) ||
				(fields.isDatosCorrectos == 'false' &&
					fields.datoIncorrecto == valueWrongConcesion &&
					fields.confirmacionConcesion == 'false')
			)
		);
	};

	const getData = (addSurvey?: boolean) => {
		const { formData }: OneFormState = store.getState();
		const { fields, headers } = formData;
		const { tc, today, url, device } = getParamsForm();

		const data = {
			...formatHeaders(headers),
			'headers[FORM_NAME]': `vw-oneform-${fields.formName}`,
			'headers[FORM_VERSION]': '1',
			'headers[FORM_URL]': url,
			'headers[FORM_DATE_INSERTION]': today,
			'headers[ORIGIN_DEVICE_TYPE]': device,
			'headers[ORIGIN_TRACKING_CODE]': tc,
			'headers[PINCODE]': dpsData.pincode.pincodeResponse.params.pincode,
			'headers[FK_SYSTEM]': idOrder.VGED_ClimaproOrderID__c,

			'fields[DPS_BRAND]': 'Volkswagen CV',
			//'fields[SF_LEAD_INSTALLATION_ID]': installation.Id,
			'fields[SF_LEAD_INSTALLATION_NAME]':
				installation.VGED_CommercialName__c,
			'fields[SF_LEAD_INSTALLATION_CODE]':
				installation.VGED_DealerCode__c,
			'fields[SF_LEAD_INSTALLATION_CODE_KVPS]': sanitizeKvps(
				installation.KVPSCode__c,
			),
			'fields[VEH_ACTUAL_FRAME]': idVehicle.Name,
			'fields[VEH_ACTUAL_PLATE]': idVehicle.VGED_RegistrationPlate__c,
			'fields[VEH_ACTUAL_MODEL]': idVehicle.VGED_ModelGroup__c
				? idVehicle.VGED_ModelGroup__c
				: dpsData.model
				? dpsData.model
				: null,
			'fields[PERSON_NAME]': fields.name,
			'fields[PERSON_SURNAME_1]': fields.surname,
			'fields[PERSON_SURNAME_2]': fields.secondSurname,
			'fields[PERSON_PHONE_MOBILE]': idPerson.PersonMobilePhone,
			'fields[PERSON_EMAIL]': idPerson.PersonEmail,
			'fields[PERSON_POSTAL_ROAD_NAME]': getSfAddressRest(
				idPerson?.PersonMailingAddress,
				'street',
			),
			'fields[PERSON_POSTAL_CP]': getSfAddressRest(
				idPerson.PersonMailingAddress,
				'postalCode',
			),
			'fields[PERSON_POSTAL_LOCATION]': getSfAddressRest(
				idPerson?.PersonMailingAddress,
				'city',
			),
			'fields[PERSON_POSTAL_PROVINCE_CODE]': formatToTwoChars(
				getSfAddressRest(idPerson.PersonMailingAddress, 'stateCode'),
			),
			'fields[PERSON_RGPD_PERFILADO]': fields.tmk
				? fields.tmk
				: 'NO INFORMADO',
			'fields[PERSON_RGPD_COM_COMERCIALES]': fields.lssi
				? fields.lssi
				: 'NO INFORMADO',

			'fields[SURVEY_ANSWER_01]':
				fields.isDatosCorrectos == 'true' ? '1' : '2',
			'fields[SURVEY_ANSWER_02]':
				fields.isDatosCorrectos == 'false'
					? fields.datoIncorrecto
					: null,
			'fields[SURVEY_ANSWER_03]':
				fields.isDatosCorrectos == 'false' &&
				fields.datoIncorrecto == valueWrongModelo
					? fields.modelo
					: null,
			'fields[SURVEY_ANSWER_04]':
				fields.isDatosCorrectos == 'false' &&
				fields.datoIncorrecto == valueWrongConcesion
					? fields.confirmacionConcesion == 'true'
						? '1'
						: '2'
					: null,
			//conditional send
			'fields[SURVEY_ANSWER_32]': dpsData.adviser,
			'fields[SURVEY_ANSWER_34]': fields.enviarConcesion,

			'flags[PERSON_RGPD_ADAPTED]': 'true',
			//'flags[FLAG_RELACION_MARCA_SIN_IC]': 'false',
			'flags[FLAG_AGENCY]':
				dpsData.agency == 'AGENCIA' ? 'true' : 'false',
		};

		if (sendSurvey() || addSurvey) {
			data['fields[SURVEY_ANSWER_06]'] = formatSinRespuestaValue(
				fields.conduccionRendimiento,
			);
			data['fields[SURVEY_ANSWER_07]'] = formatSinRespuestaValue(
				fields.conduccionComodidad,
			);
			data['fields[SURVEY_ANSWER_08]'] = formatSinRespuestaValue(
				fields.conduccionConsumo,
			);
			data['fields[SURVEY_ANSWER_09]'] = formatSinRespuestaValue(
				fields.conduccionAutonomia,
			);
			data['fields[SURVEY_ANSWER_10]'] = formatSinRespuestaValue(
				fields.conduccionMotivo,
			);
			data['fields[SURVEY_ANSWER_11]'] = formatSinRespuestaValue(
				fields.rendimientoCargaGestion,
			);
			data['fields[SURVEY_ANSWER_12]'] = formatSinRespuestaValue(
				fields.rendimientoCarga,
			);
			data['fields[SURVEY_ANSWER_13]'] = formatSinRespuestaValue(
				fields.rendimientoMotivo,
			);
			data['fields[SURVEY_ANSWER_14]'] = formatSinRespuestaValue(
				fields.exteriorDiseno,
			);
			data['fields[SURVEY_ANSWER_15]'] = formatSinRespuestaValue(
				fields.exteriorPuertas,
			);
			data['fields[SURVEY_ANSWER_16]'] = formatSinRespuestaValue(
				fields.exteriorMaletero,
			);
			data['fields[SURVEY_ANSWER_17]'] = formatSinRespuestaValue(
				fields.exteriorMotivo,
			);
			data['fields[SURVEY_ANSWER_18]'] = formatSinRespuestaValue(
				fields.interiorDiseno,
			);
			data['fields[SURVEY_ANSWER_19]'] = formatSinRespuestaValue(
				fields.interiorAlmacenamiento,
			);
			data['fields[SURVEY_ANSWER_20]'] = formatSinRespuestaValue(
				fields.interiorAsiento,
			);
			data['fields[SURVEY_ANSWER_21]'] = formatSinRespuestaValue(
				fields.interiorFunciones,
			);
			data['fields[SURVEY_ANSWER_22]'] = formatSinRespuestaValue(
				fields.interiorAC,
			);
			data['fields[SURVEY_ANSWER_23]'] = formatSinRespuestaValue(
				fields.interiorMotivo,
			);
			data['fields[SURVEY_ANSWER_24]'] = formatSinRespuestaValue(
				fields.asistenciaConduccion,
			);
			data['fields[SURVEY_ANSWER_25]'] = formatSinRespuestaValue(
				fields.asistenciaFuncionalidad,
			);
			data['fields[SURVEY_ANSWER_26]'] = formatSinRespuestaValue(
				fields.asistenciaNavegacion,
			);
			data['fields[SURVEY_ANSWER_27]'] = formatSinRespuestaValue(
				fields.asistenciaMotivo,
			);
			data['fields[SURVEY_ANSWER_28]'] = formatSinRespuestaValue(
				fields.softwareInicio,
			);
			data['fields[SURVEY_ANSWER_29]'] = formatSinRespuestaValue(
				fields.softwareOnline,
			);
			data['fields[SURVEY_ANSWER_33]'] = formatSinRespuestaValue(
				fields.softwareIntegracion,
			);
			data['fields[SURVEY_ANSWER_35]'] = formatSinRespuestaValue(
				fields.softwareFunciones,
			);
			data['fields[SURVEY_ANSWER_36]'] = formatSinRespuestaValue(
				fields.softwareUpdates,
			);
			data['fields[SURVEY_ANSWER_37]'] = formatSinRespuestaValue(
				fields.softwareMotivo,
			);
			data['fields[SURVEY_ANSWER_38]'] = formatSinRespuestaValue(
				fields.campingInterior,
			);
			data['fields[SURVEY_ANSWER_39]'] = formatSinRespuestaValue(
				fields.campingEspacio,
			);
			data['fields[SURVEY_ANSWER_40]'] = formatSinRespuestaValue(
				fields.campingTecho,
			);
			data['fields[SURVEY_ANSWER_41]'] = formatSinRespuestaValue(
				fields.campingCocina,
			);
			data['fields[SURVEY_ANSWER_42]'] = formatSinRespuestaValue(
				fields.campingFunciones,
			);
			data['fields[SURVEY_ANSWER_43]'] = formatSinRespuestaValue(
				fields.campingComodidad,
			);
			data['fields[SURVEY_ANSWER_44]'] = formatSinRespuestaValue(
				fields.campingEnergia,
			);
			data['fields[SURVEY_ANSWER_45]'] = formatSinRespuestaValue(
				fields.campingMotivo,
			);
			data['fields[SURVEY_ANSWER_46]'] = formatSinRespuestaValue(
				fields.generalCalidad,
			);
			data['fields[SURVEY_ANSWER_47]'] = formatSinRespuestaValue(
				fields.generalRelacion,
			);
			data['fields[SURVEY_ANSWER_48]'] = formatSinRespuestaValue(
				fields.generalVehiculo,
			);
			data['fields[SURVEY_ANSWER_49]'] = formatSinRespuestaValue(
				fields.generalMotivo,
			);
			data['fields[SURVEY_ANSWER_50]'] = fields.usoCliente;
		}

		if (
			idOrder.VGED_CEMDeliveryDate__c &&
			idOrder.VGED_CEMDeliveryDate__c != 'null'
		) {
			data['fields[CEM_DATE]'] = getCemDate(
				idOrder.VGED_CEMDeliveryDate__c,
			);
		}

		return data;
	};

	useEffect(() => {
		if (dev) {
			console.log(getData(true));
		}
	}, [formData]);

	const sendForm = (): Promise<boolean> => {
		return new Promise<any>(async (resolve, reject) => {
			const dataStringified = JSON.stringify(getData());
			const dataParsed = JSON.parse(dataStringified);
			const formData = formDataBuilder(dataParsed);
			checkUndefinedsInData(getData(), 'Venta Producto');
			const response = await oneformBFFNdpsSend(formData);

			if (response?.data?.status?.code == 200) {
				dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
				resolve(true);
			} else {
				resolve(false);
			}
		});
	};

	/**
	 * Se extrae la lógica para poder utilizarla por separado sin tener que usar las funciones de loading o updateSteps ya que hay una pregunta en la que podemos eliminar y añadir un step en el mismo paso.
	 * @param stepsToAdd
	 * @param alternativeSteps
	 * @return finalSteps
	 */
	const addingStepsLogic = (
		stepsToAdd: string[],
		alternativeSteps?: Steps[],
	) => {
		const { steps: actualSteps, screenIndex } = store.getState().formInfo;
		const stepsToUse = alternativeSteps ? alternativeSteps : actualSteps;
		// Hay que revertir los steps para que se añadan en el orden correcto
		const indexesInSteps = stepsToAdd
			.reverse()
			.map(step => getIndexInSteps(stepsToUse, step));
		let newSteps = [...stepsToUse];

		const allAvailableSteps = [
			...getStepsVentaProductoComerciales(
				isElectrico,
				isHibrido,
				isCamper,
				carline,
				getInstallationName(),
			),
		];

		indexesInSteps.forEach((index, i) => {
			if (index == -1) {
				newSteps = addRemovedStep(
					allAvailableSteps,
					stepsToUse,
					stepsToAdd[i],
					screenIndex,
				);
			}
		});
		const finalSteps = resetStepsScreenIndex(newSteps);
		return finalSteps;
	};

	const addSteps = (stepsToAdd: string[]) => {
		setLoading(true);

		const finalSteps = addingStepsLogic(stepsToAdd);
		updateSteps(finalSteps);
		handleNextStep();

		setLoading(false);
	};

	const removeSteps = (stepsToDelete: string[]) => {
		const { steps } = store.getState().formInfo;
		if (!steps) return;
		setLoading(true);
		const finalSteps = removeMultipleStepsAndResetScreenIndex(
			steps,
			stepsToDelete,
		);
		updateSteps(finalSteps);
		setLoading(false);
	};

	const updateSteps = (steps: Steps[]) => {
		dispatch({ type: 'UPDATE_STEPS', payload: steps });
		dispatch({
			type: 'UPDATE_LAST_STEP',
			payload: steps[steps.length - 1],
		});
		dispatch({ type: 'SET_NUMBER_OF_SCREENS', payload: steps.length });
	};

	const updateStepHidden = (stepName: string, hidden: boolean) => {
		const { steps } = store.getState().formInfo;
		const updatedSteps = steps.map(step =>
			step.name === stepName ? { ...step, hidden } : step,
		);
		updateSteps(updatedSteps);
	};

	const hideStep = (stepName: string) => {
		updateStepHidden(stepName, true);
	};
	const showStep = (stepName: string) => {
		updateStepHidden(stepName, false);
	};

	const handleShowMotivo = (nameOfMotivoStep: string, group?: string[]) => {
		if (
			!nameOfMotivoStep ||
			!group ||
			group.length === 0 ||
			group.some(val => !val)
		)
			return; // Faltan datos o hay algun undefined/null en las respuestas (grupo no respondido todavia)

		if (group.some(val => isLowRating(val))) {
			showStep(nameOfMotivoStep);
		} else {
			hideStep(nameOfMotivoStep);
			delete fields[stepNameToFieldName(nameOfMotivoStep)];
		}
	};

	const handleGeneralShowMotivo = (
		nameOfMotivoStep: string,
		group?: string[],
	) => {
		if (
			!nameOfMotivoStep ||
			!group ||
			group.length === 0 ||
			group.some(val => !val)
		)
			return; // Faltan datos o hay algun undefined/null en las respuestas (grupo no respondido todavia)

		if (group.some(val => isNoRating(val))) {
			hideStep(nameOfMotivoStep);
			delete fields[stepNameToFieldName(nameOfMotivoStep)];
		} else {
			showStep(nameOfMotivoStep);
		}
	};

	useEffect(() => {
		if (!isDatosCorrectos) {
			return;
		}
		if (isDatosCorrectos == 'true') {
			const steps = store.getState().formInfo.steps;
			const modeloStepIndex = getIndexInSteps(steps, 'seleccionModelo');
			// En el caso de elegir que los datos son incorrectos, llegar a confirmación y volver atrás hay que regenerar todos los pasos.
			if (modeloStepIndex == -1) {
				const initialSteps = store.getState().formInfo.initialSteps;
				const finalSteps = removeMultipleStepsAndResetScreenIndex(
					initialSteps,
					[
						'datoIncorrecto',
						'seleccionModelo',
						'confirmacionConcesion',
					],
				);
				updateSteps(finalSteps);
			} else {
				removeSteps([
					'datoIncorrecto',
					'seleccionModelo',
					'confirmacionConcesion',
				]);
			}
		} else {
			addSteps([
				'datoIncorrecto',
				'seleccionModelo',
				'confirmacionConcesion',
			]);
		}
	}, [isDatosCorrectos]);

	useEffect(() => {
		if (!datoIncorrecto) {
			return;
		}
		if (
			datoIncorrecto == valueWrongMarca ||
			datoIncorrecto == valueWrongPersona
		) {
			const pastSteps = store.getState().formInfo.steps;
			const newsteps = [
				pastSteps[0],
				pastSteps[1],
				pastSteps[pastSteps.length - 1],
			];
			const finalSteps = resetStepsScreenIndex(newsteps);
			updateSteps(finalSteps);
		}
		if (datoIncorrecto == valueWrongConcesion) {
			const initialSteps = store.getState().formInfo.initialSteps;
			const finalSteps = removeMultipleStepsAndResetScreenIndex(
				initialSteps,
				['seleccionModelo'],
			);
			updateSteps(finalSteps);
		} else if (datoIncorrecto == valueWrongModelo) {
			const initialSteps = store.getState().formInfo.initialSteps;
			const finalSteps = removeMultipleStepsAndResetScreenIndex(
				initialSteps,
				['confirmacionConcesion'],
			);
			updateSteps(finalSteps);
		}
	}, [datoIncorrecto]);

	useEffect(() => {
		if (!confirmacionConcesion) {
			return;
		}
		if (confirmacionConcesion == 'true') {
			const initialSteps = store.getState().formInfo.initialSteps;
			const finalSteps = removeMultipleStepsAndResetScreenIndex(
				initialSteps,
				['seleccionModelo'],
			);
			updateSteps(finalSteps);
		} else {
			const pastSteps = store.getState().formInfo.steps;
			const newsteps = [
				pastSteps[0],
				pastSteps[1],
				pastSteps[2],
				pastSteps[pastSteps.length - 1],
			];
			const finalSteps = resetStepsScreenIndex(newsteps);
			updateSteps(finalSteps);
		}
	}, [confirmacionConcesion]);

	useEffect(() => {
		if (!enviarConcesion) {
			return;
		}
		if (enviarConcesion == '1') {
			addSteps(['datosPersonales']);
		} else {
			removeSteps(['datosPersonales']);
		}
	}, [enviarConcesion]);

	/**
	 * Lógica steps mostrar motivos por grupo
	 */
	const conduccionCombustible = [
		fields.conduccionRendimiento,
		fields.conduccionComodidad,
		fields.conduccionConsumo,
	];
	const conduccionElectrico = [
		fields.conduccionRendimiento,
		fields.conduccionComodidad,
		fields.conduccionAutonomia,
	];
	const conduccionHibrido = [
		fields.conduccionRendimiento,
		fields.conduccionComodidad,
		fields.conduccionConsumo,
		fields.conduccionAutonomia,
	];
	useEffect(() => {
		handleShowMotivo(
			'conduccionMotivo',
			isElectrico
				? conduccionElectrico
				: isHibrido
				? conduccionHibrido
				: conduccionCombustible,
		);
	}, conduccionHibrido); // conduccionHibrido tiene todos los fields

	const rendimiento = [
		fields.rendimientoCargaGestion,
		fields.rendimientoCarga,
	];
	useEffect(() => {
		handleShowMotivo('rendimientoMotivo', rendimiento);
	}, rendimiento);

	const exterior = [
		fields.exteriorDiseno,
		fields.exteriorPuertas,
		fields.exteriorMaletero,
	];
	useEffect(() => {
		handleShowMotivo('exteriorMotivo', exterior);
	}, exterior);

	const interior = [
		fields.interiorDiseno,
		fields.interiorAlmacenamiento,
		fields.interiorAsiento,
		fields.interiorFunciones,
		fields.interiorAC,
	];
	useEffect(() => {
		handleShowMotivo('interiorMotivo', interior);
	}, interior);

	const asistencia = [
		fields.asistenciaConduccion,
		fields.asistenciaFuncionalidad,
		fields.asistenciaNavegacion,
	];
	useEffect(() => {
		handleShowMotivo('asistenciaMotivo', asistencia);
	}, asistencia);

	const software = [
		fields.softwareInicio,
		fields.softwareOnline,
		fields.softwareIntegracion,
		fields.softwareFunciones,
		fields.softwareUpdates,
	];
	useEffect(() => {
		handleShowMotivo('softwareMotivo', software);
	}, software);

	const camping = [
		fields.campingInterior,
		fields.campingEspacio,
		fields.campingTecho,
		fields.campingCocina,
		fields.campingFunciones,
		fields.campingComodidad,
		fields.campingEnergia,
	];
	useEffect(() => {
		handleShowMotivo('campingMotivo', camping);
	}, camping);

	const general = [
		fields.generalCalidad,
		fields.generalRelacion,
		fields.generalVehiculo,
	];
	useEffect(() => {
		handleGeneralShowMotivo('generalMotivo', general);
	}, general);

	/**
	 * Form constructor
	 */
	const sanitizeSteps = (steps: Steps[]): Steps[] => {
		const removeUndefined = steps.filter(step => step !== undefined);
		const resetIndexScreens = removeUndefined.map((step, index) => ({
			...step,
			screenIndex: index,
		}));
		return resetIndexScreens;
	};

	const getFormInfo = (steps: Steps[]) => {
		const randomizedSteps = sanitizeSteps(steps);

		if (dev) {
			console.log('Steps', randomizedSteps);
		}

		return {
			firstStep: randomizedSteps[0],
			lastStep: randomizedSteps[randomizedSteps.length - 1],
			stepsHistory: [0],
			numberOfScreens: randomizedSteps.length,
			newSteps: randomizedSteps,
		};
	};

	useEffect(() => {
		if (!installation) return null;

		const { firstStep, lastStep, stepsHistory, numberOfScreens, newSteps } =
			getFormInfo(
				getStepsVentaProductoComerciales(
					isElectrico,
					isHibrido,
					isCamper,
					carline,
					getInstallationName(),
				),
			);

		const NuevoFormInfo: Partial<FormInfo> = {
			formStarted: true,
			sendFormCallback: sendForm,
			fullScreen: firstStep.fullScreen ? true : false,
			lastStep,
			numberOfScreens,
			formTheme: 'main',
			notALayer: true,
			formType: 'inPage',
			screenIndex: firstStep.screenIndex,
			step: firstStep,
			steps: newSteps
				? newSteps
				: getStepsVentaProductoComerciales(
						isElectrico,
						isHibrido,
						isCamper,
						carline,
						getInstallationName(),
				  ),
			stepsHistory,
			thankYouComponent: (
				<CEMVentaProductoThankYouComerciales idPerson={idPerson} />
			),
			hideLegal: true, // Ocultamos default legales y añadimos custom legales en Confirmacion
		};

		initializeForm(NuevoFormInfo, NuevoFormData);
	}, [installation]);

	return !loading ? (
		<FormController
			steps={getStepsVentaProductoComerciales(
				isElectrico,
				isHibrido,
				isCamper,
				carline,
				getInstallationName(),
			)}
			screenType="full-screen"
		/>
	) : null;
}
